<template>
  <ul
    class="list-none text-sm font-light list-inside text-left text-gray-600 flex flex-col space-y-2"
  >
    <SubscriptionDetail
      v-for="(detail, index) in details"
      :key="index"
      :content="detail"
    />
  </ul>
</template>

<script>
import SubscriptionDetail from './SubscriptionDetail.vue';

export default {
  props: {
    details: {
      type: Array,
      required: true
    }
  },

  components: {
    SubscriptionDetail
  }
};
</script>